import React from 'react'

import { logEvent } from 'firebase/analytics'
import { Header } from './Header'
import { Content } from './Content'
import { Footer } from './Footer'
import { Container } from './styles'
import { FeedbackPortalModal } from './FeedbackPortalModal'
import { message, sendFeedback } from '~/services'
import { useMessageCenter } from '~/context'
import { IFeedbackValues } from '~/interfaces'
import { Divider } from '~/styles'

import { analytics } from '~/firebase-analytics'

export interface ModalFeedbackProps {
  showFeedbackModal: boolean
  onClose: () => void
}

/**
 * Componente ModalFeedback que utiliza o react-hook-form para gerenciar o estado do campo.
 *
 * @param {ModalFeedbackProps} props - Propriedades para configurar o componente ModalFeedback.
 * @returns {JSX.Element} O componente ModalFeedback renderizado.
 */

export const ModalFeedback = ({ onClose, showFeedbackModal }: ModalFeedbackProps): JSX.Element => {
  const { throwCustomAlert, throwErrorModal } = useMessageCenter()

  const onSubmitForm = async (data: IFeedbackValues) => {
    const feedbackValues: IFeedbackValues = {
      type: data.type,
      feedback: data.feedback
    }

    try {
      await sendFeedback(feedbackValues)
      throwCustomAlert({
        title: message('feedback.feedbackSentTitle'),
        buttonMessage: message('feedback.feedbackSentButton'),
        subtitle: message('feedback.feedbackSentMessage')
      })
      logEvent(analytics, 'feedback_sent', { type: data.type })
      onClose()
    } catch (error) {
      throwErrorModal({
        title: message('feedback.feedbackNotSentTitle'),
        buttonMessage: message('feedback.feedbackSentButton'),
        subtitle: message('feedback.feedbackNotSentMessage')
      })
      console.log('Fail to send feedback', error)
    }
  }

  return (
    <FeedbackPortalModal show={showFeedbackModal} onClose={onClose}>
      <Container>
        <Header />
        <Divider marginTop="2.5rem" marginBottom="1.5rem" />
        <Content onSubmit={onSubmitForm} />
        <Divider marginBlock="1rem" />
        <Footer />
      </Container>
    </FeedbackPortalModal>
  )
}
